import { MouseEventHandler } from 'react';
import cx from 'classnames';
import { V4, isMacOS } from '@moleculeone/utils';
import { extractMolEvent } from '@moleculeone/draw';
import { Vector } from '@moleculeone/types';

import { styled } from '../../../stitches.config';

export interface Viewport {
  max: Vector;
  min: Vector;
}

export interface SVGMolSpaceProps {
  children?: any;
  className?: string;
  border?: number | Vector;
  width?: number;
  height?: number;
  viewport: Viewport;
  padding?: number;
  onMouseDown?: MouseEventHandler;
  onMouseUp?: MouseEventHandler;
  onMouseMove?: MouseEventHandler;
  onMouseEvent?: MouseEventHandler;
  onContextMenu?: MouseEventHandler;
}

const SVG = styled('svg', {
  boxSizing: 'border-box',
  borderRadius: '3px',
  display: 'block',
  overflow: 'visible',
});

export function SVGMolSpace(props: SVGMolSpaceProps) {
  const {
    className = '',
    border = 10,
    children,
    padding,
    onMouseEvent,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onContextMenu,
    viewport,
    ...restProps
  } = props;

  const calculateViewBox = (padding = 0) => {
    let borderValue = border;
    if (typeof border === 'number') {
      borderValue = V4.vect(border, border);
    }
    borderValue = borderValue as Vector;

    let min = V4.sub(viewport.min, borderValue);
    min = V4.sub(min, V4.vect(padding, padding));
    const size = V4.sub(V4.add(viewport.max, borderValue), min);
    const box = [min[0].toString(), min[1].toString(), size[0].toString(), size[1].toString()];
    return box;
  };

  const onMouse = (primaryHandler: any) => (event: any) => {
    const handler = primaryHandler || onMouseEvent;
    const shouldEventFire = handler != null && event.button <= 1 && !(isMacOS() && event.ctrlKey);

    if (!shouldEventFire) {
      return;
    }

    const molEvent = extractMolEvent(event);
    handler(event, molEvent);
  };

  return (
    <SVG
      id="svg_container"
      className={cx(className, 'mol-svg')}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={calculateViewBox(padding).join(' ')}
      onMouseDown={onMouse(onMouseDown)}
      onMouseMove={onMouse(onMouseMove)}
      onMouseUp={onMouse(onMouseUp)}
      onContextMenu={onContextMenu}
      data-test="svg-space"
      {...restProps}
    >
      {children}
    </SVG>
  );
}
